<div class="container" *transloco="let t">

    <div class="row">
        <div class="col text-center">
            <br/><br/><br/><br/><br/>
            <span class="fs-5">{{ t('Loading') }} <i class="fa-solid fa-spinner fa-spin fa-xl"></i> </span><br>
            <br/><br/><br/><br/>
            {{ t('Taking too long?') }} <button type="button" class="btn btn-link" (click)="goToHome()" >{{ t('Click here') }}...</button>
        </div>
    </div>
</div>
